import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentJointVerifyIdentityData,
  type EnrollmentJointVerifyIdentitySubmitOutput,
} from '../../../../models'

export const getEnrollmentJointVerifyIdentityDataMock: EnrollmentJointVerifyIdentityData = {
  isError: false,
  errors: [],
  activePerson: {
    applicationId: '1234567890',
    path: '/enrollment/joint/verify-identity',
    progress: 60,
    dateOfBirth: '1990-01-15',
    residencyStatus: 'US_CITIZEN',
    citizenshipCountries: ['US'],
  },
}

export const submitEnrollmentJointVerifyIdentityDataMock: EnrollmentJointVerifyIdentitySubmitOutput = {
  isError: false,
  errors: [],
  activePerson: {
    path: '/enrollment/joint/next-page-here',
  },
}

export const mockGetEnrollmentJointVerifyIdentityData = graphql.mutation('getEnrollmentJointVerifyIdentityData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: getEnrollmentJointVerifyIdentityDataMock } })
})

export const mockSubmitEnrollmentJointVerifyIdentityData = graphql.mutation(
  'submitEnrollmentJointVerifyIdentityData',
  () => {
    return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointVerifyIdentityDataMock } })
  },
)

export const mockEnrollmentJointVerifyIdentity = [
  mockGetEnrollmentJointVerifyIdentityData,
  mockSubmitEnrollmentJointVerifyIdentityData,
]
